import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerSubscription,
  BackendMutationUnpauseCustomerSubscriptionArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation UnpauseCustomerSubscription($customerId: ID!) {
    unpauseCustomerSubscription(customerId: $customerId) {
      status
    }
  }
`;

type Variables = BackendMutationUnpauseCustomerSubscriptionArgs;
type Result = Pick<BackendCustomerSubscription, 'status'>;

export const unpauseCustomerSubscription = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
